import React from 'react';
import { Reveal } from './Reveal';
const STEPS = [{
  num: '01',
  title: 'Identificas la Trampa',
  body: 'Entiendes por qué estás enganchado/a químicamente (Dopamina vs. Amor).'
}, {
  num: '02',
  title: 'Rompes el Altar',
  body: 'Separas a la persona real del pedestal donde la pusiste.'
}, {
  num: '03',
  title: 'Ejecutas el Desanclaje',
  body: 'Limpias tu entorno digital y mental con pasos prácticos sin retorno.'
}];
export function HowItWorks() {
  return <section className="w-full bg-midnight py-24" data-id="element-63">
      <div className="mx-auto max-w-5xl px-6" data-id="element-64">
        <Reveal data-id="element-65">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-electric" data-id="element-66">
            Cómo funciona
          </p>
          <h2 className="mt-4 font-display text-3xl font-semibold text-cream sm:text-4xl" data-id="element-67">
            Tres movimientos hacia tu paz.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-68">
          {STEPS.map((step, i) => <Reveal key={step.num} delay={i * 0.1} data-id="element-69">
              <div className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-8" data-id="element-70">
                <span className="font-display text-5xl font-semibold text-rose-glow/70" data-id="element-71">
                  {step.num}
                </span>
                <h3 className="mt-4 font-display text-xl font-semibold text-cream" data-id="element-72">
                  {step.title}
                </h3>
                <p className="mt-2 leading-relaxed text-muted" data-id="element-73">{step.body}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}